var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerificationSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_51",
    "data-name": "Layer 51",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #15233f;\n      }\n\n      .cls-3 {\n        fill: #c2c7cc;\n        opacity: .25;\n      }\n\n      .cls-4 {\n        fill: #4f7fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250,
    cy: 250,
    r: 162.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 109,
    cy: 125,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.91,148.15c-1.78,0-3.56-.62-5-1.87l-17.52-15.17c-3.19-2.76-3.54-7.59-.77-10.78,2.76-3.18,7.59-3.54,10.78-.77l12.02,10.41,24.66-25.75c2.92-3.06,7.76-3.15,10.81-.23,3.05,2.92,3.15,7.76.23,10.8l-29.69,31.01c-1.5,1.57-3.51,2.36-5.52,2.36Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 189,
    y: 112.5,
    width: 234,
    height: 25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 109,
    cy: 250,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.91,273.15c-1.78,0-3.56-.62-5-1.87l-17.52-15.17c-3.19-2.76-3.54-7.59-.77-10.78,2.76-3.18,7.59-3.54,10.78-.77l12.02,10.41,24.66-25.75c2.92-3.06,7.76-3.15,10.81-.23,3.05,2.92,3.15,7.76.23,10.8l-29.69,31.01c-1.5,1.57-3.51,2.36-5.52,2.36Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 189,
    y: 237.5,
    width: 234,
    height: 25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 109,
    cy: 372.32,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.91,395.46c-1.78,0-3.56-.62-5-1.87l-17.52-15.17c-3.19-2.76-3.54-7.59-.77-10.78,2.76-3.18,7.59-3.54,10.78-.77l12.02,10.41,24.66-25.75c2.92-3.06,7.76-3.15,10.81-.23,3.05,2.92,3.15,7.76.23,10.8l-29.69,31.01c-1.5,1.57-3.51,2.36-5.52,2.36Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 189,
    y: 359.82,
    width: 234,
    height: 25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerificationSteps);
export default __webpack_public_path__ + "static/media/icon_verification_steps.ccd90630f51b97cd84d3b2b389c6a23b.svg";
export { ForwardRef as ReactComponent };